import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { FormsServiceService } from '../../../api/services/forms-service.service';
import { InputTextFieldComponent } from '../input-text-field/input-text-field.component';
import { ModalRendererComponent } from '../../widgets/modal-renderer/modal-renderer.component';
import { WorkflowService } from '../../../api/services/workflow.service';
import { SseService } from '../../../api/services/sse.service';
import { FormRenderComponent } from '../../widgets/form-render/form-render.component';
import { DataViewWithLoaderComponent } from '../data-view-with-loader/data-view-with-loader.component';
import { IntegrationIconService } from '../../../api/services/integration-icon.service';

@Component({
  selector: 'app-checkbox-type-four',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ModalRendererComponent,
  ],
  templateUrl: './checkbox-type-four.component.html',
  styleUrl: './checkbox-type-four.component.css',
})
export class CheckboxTypeFourComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Output() handleTaskMappingDependency = new EventEmitter<{
    fieldName: string;
    tags: any[];
    selectedQuestion: any;
  }>();
  showValidationError = false;
  fieldsData: any;
  endpoint = environment.api_endpoint;
  selectedOptions: any[] = [];
  loadingCards: Set<string> = new Set();
  modalTitle: string = '';
  activeModalContext: any;
  activeComingSoonOption: any;
  workflowData: any;
  currentRecordId: any;
  currentNodeId: any;
  currentNode: any;
  recordID: any;
  nextNodes: any;
  targetWorkflowId: any;
  targetValue: any;
  workflowId: any;
  accessToken: any;
  previousNodeId: any;
  private lastTaskMappingSignature = '';
  @ViewChild(FormRenderComponent)
  FormRenderComponent!: FormRenderComponent;
  @ViewChild(DataViewWithLoaderComponent)
  DataViewWithLoaderComponent!: DataViewWithLoaderComponent;
  @ViewChild(ModalRendererComponent) modalRendererRef!: ModalRendererComponent;
  isLoading: boolean = true;
  skeletonArray = Array.from({ length: 6 });
  constructor(
    private formService: FormsServiceService,
    private workflowService: WorkflowService,
    private SseService: SseService,
    private cdr: ChangeDetectorRef,
    private integrationIconService: IntegrationIconService,
  ) {}
  ngOnInit() {
    this.getData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes['formGroup'] || changes['fields']) &&
      this.formGroup &&
      this.fields
    ) {
      this.getData();
    }
  }

  get control() {
    return this.formGroup.get(this.fields.fieldName);
  }

  private getSelectedIds(): string[] {
    const value = this.control?.value ?? [];
    return (Array.isArray(value) ? value : [value])
      .filter((item: any) => item !== null && item !== undefined && item !== '')
      .map((item: any) => item.toString());
  }

  private getSelectedTags(tagsControl: any): string[] {
    const value = tagsControl?.value ?? [];
    return (Array.isArray(value) ? value : [value]).filter(
      (item: any) => item !== null && item !== undefined && item !== '',
    );
  }

  private applySelectedIntegration(
    optionId: string,
    optionName: string,
    tagsControl: any,
  ): string[] {
    const selectedIds =
      this.fields?.fieldType === 'singleSelect'
        ? [optionId]
        : Array.from(new Set([...this.getSelectedIds(), optionId]));
    const selectedTags =
      this.fields?.fieldType === 'singleSelect'
        ? [optionName]
        : Array.from(
            new Set([...this.getSelectedTags(tagsControl), optionName]),
          );

    this.control?.setValue(selectedIds);
    tagsControl?.setValue(selectedTags);
    this.selectedOptions = [...selectedIds];
    this.emitTaskMappingDependency(selectedTags);

    this.control?.markAsTouched();
    this.control?.updateValueAndValidity();
    this.showValidationError = false;

    return selectedIds;
  }

  /** Function to get the data by api or static */
  getData() {
    this.isLoading = true;
    if (this.fields.options.isStatic == true) {
      this.fieldsData = [
        {
          _id: '68511adfc23e7a0f7ae56345',
          name: 'Microsoft Entra ID',
          subText: 'Microsoft Azure Entra for identity and access management.',
          connectionType: 'OAuth',
          integration: {
            authUrl: '{{base}}/azure-entra/oauth/start',
          },
          status: 'disconnected',
          iconUrl:
            'https://developmentcontent.blob.core.windows.net/resources/infrastructure/MicroEntra-ID.png',
          createdDate: '2025-06-03T11:01:21.731806Z',
          lastUpdatedAt: '2025-06-03T11:01:21.731806Z',
          tags: ['azure', 'entra', 'iam', 'oauth', 'identity'],
          fieldDependencies: [
            {
              trigger: 'onClick',
              condition: [
                {
                  conditions: [
                    {
                      type: 'modal',
                      targetType: 'workflow',
                      targetValue: '68c3ecd845a7a695efb493f2', // workflow ID
                      action: 'connect', // OPTIONAL but recommended for clarity
                    },
                  ],
                },
                {
                  conditions: [
                    {
                      type: 'modal',
                      targetType: 'form',
                      targetValue: '6918913678e092ac8b8ae048', // form ID
                      action: 'disconnect', // OPTIONAL but recommended for clarity
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          _id: '68511b03c23e7a0f7ae563a7',
          name: 'Google Workspace',
          subText: 'Google Workspace IAM integration.',
          connectionType: 'OAuth',
          integration: {
            authUrl: '{{base}}/google/oauth/start',
          },
          status: 'disconnected',
          iconUrl:
            'https://developmentcontent.blob.core.windows.net/resources/infrastructure/GWS.png',
          createdDate: '2025-06-03T11:01:21.731806Z',
          lastUpdatedAt: '2025-06-03T11:01:21.731806Z',
          tags: ['google', 'workspace', 'iam', 'oauth', 'identity'],
          fieldDependencies: [
            {
              trigger: 'onClick',
              condition: [
                {
                  conditions: [
                    {
                      type: 'modal',
                      targetType: 'workflow',
                      targetValue: '690df463d4384f0bcc44e1e1',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          _id: '',
          name: 'LDAP',
          subText: 'Lightweight Directory Access Protocol integration.',
          connectionType: 'API Key',
          integration: {
            authUrl: '',
          },
          status: 'disconnected',
          iconUrl:
            'https://developmentcontent.blob.core.windows.net/resources/infrastructure/LDAP.png',
          createdDate: '2025-06-03T11:01:21.731806Z',
          lastUpdatedAt: '2025-06-03T11:01:21.731806Z',
          tags: ['ldap', 'directory', 'iam', 'identity', 'access'],
          fieldDependencies: null,
        },
      ];
      if (this.fields?.value?.length && this.fieldsData) {
        const selectedIds = this.fields.value.map((v: any) => v.toString());

        // Only keep those that still exist in fieldsData
        const validSelections = this.fieldsData
          .map((item: any) => item._id.toString())
          .filter((id: string) => selectedIds.includes(id));

        this.control?.setValue(validSelections, { emitEvent: false });
      }

      this.restoreTagsFromSelectedOptions();
      this.isLoading = false;
      //  this.fieldsData = this.fields.options.staticOptions;
    } else {
      const formId = this.fields.options.source.formID;
      const api_endpoint = this.endpoint;
      const method = this.fields.options.source.method;
      let url = this.fields.options.source.apiUrl;
      const replacements = {
        formID: formId,
        api_endpoint: api_endpoint,
      };
      url = this.formService.replaceTemplateTokens(url, replacements);
      const accessToken = localStorage.getItem('accessToken');
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      };
      this.formService.loadData(method, url, headers).subscribe({
        next: (res) => {
          this.fieldsData = res.data.records;
          this.restoreTagsFromSelectedOptions();
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.fieldsData = [];
          this.isLoading = false;
          this.cdr.detectChanges();
        },
      });
    }
  }

  restoreTagsFromSelectedOptions() {
    if (!this.fieldsData?.length) return;

    const currentValue = (this.fields?.value || []).map((v: any) =>
      v.toString(),
    );

    const selectedOptions = this.fieldsData.filter((opt: any) =>
      currentValue.includes(opt._id?.toString()),
    );

    const restoredIds = selectedOptions.map((opt: any) => opt._id.toString());
    if (JSON.stringify(currentValue) !== JSON.stringify(restoredIds)) {
      this.control?.setValue(restoredIds, { emitEvent: false });
    }

    const selectedNames = selectedOptions.map((opt: any) => opt.name);
    this.formGroup
      .get(this.fields.fieldName + 'Tags')
      ?.setValue(selectedNames, { emitEvent: false });
    this.emitTaskMappingDependency(selectedNames);
  }

  isSelected(option: any): boolean {
    const value = (this.control?.value || this.fields?.value || []).map(
      (v: any) => v.toString(),
    );

    const { nextNodeId } = this.resolveNavigationTargets(this.currentNode);

    const nodeIndex = this.workflowData?.nodes?.findIndex(
      (n: any) => n._id === nextNodeId,
    );
    const isLastNode =
      nodeIndex !== -1 && nodeIndex === this.workflowData?.nodes?.length - 1;

    // ✅ Only show selected if it's the last node and saved
    if (isLastNode && this.currentNode?.isSaved) {
      return value?.includes(option._id?.toString());
    }

    // Otherwise, rely on current control value
    return value.includes(option._id?.toString());
  }

  /** Function to disable another cards  */
  isDisabled(option: any): boolean {
    if (this.fields?.fieldType !== 'singleSelect') return false;
    const value = (this.control?.value || this.fields?.value || []).map(
      (v: any) => v.toString(),
    );
    return value.length > 0 && !value.includes(option._id?.toString());
  }

  /** Helper method to handle OAuth / Integration URL redirects */
  private openIntegrationUrl(option: any): void {
    if (option.integration?.authUrl) {
      let authUrlTemplate = option.integration.authUrl;
      const catCode = option.categoryCode ||
        option.integration?.categoryCode ||
        this.fields?.displayName ||
        '';
      const recordIdVal = String(this.recordID || this.activeModalContext?.recordID || this.currentRecordId || '');
      let authUrl = authUrlTemplate
        .replace('{{base}}', this.endpoint)
        .replace(/\{\{categoryCode\}\}/g, catCode)
        .replace(/\{\{integrationProfileRecordID\}\}/g, recordIdVal);

      this.accessToken = localStorage.getItem('accessToken') || '';
      const separator = authUrl.includes('?') ? '&' : '?';
      authUrl += `${separator}at=${encodeURIComponent(this.accessToken)}`;

      window.open(authUrl, '_blank');
    } else if (
      option.integration?.allowIntegration &&
      option.integration?.url
    ) {
      window.open(option.integration.url, '_blank');
    }
  }

  /** Function to toggle the card and push the selection into array */
  toggleSelection(option: any, type?: any): void {
    if (option?.fieldDependencies == null) {
      this.activeComingSoonOption = option;
      const modalId = `coming_soon_modal_${this.fields.fieldName}`;
      const mEl = document.getElementById(modalId);
      if (mEl) mEl.classList.add('show');
      return;
    }

    const optionId = option?._id?.toString();
    if (!optionId) return;

    const tagsControl = this.formGroup.get(`${this.fields.fieldName}Tags`);
    const currentValues = this.getSelectedIds();
    const isSelected = currentValues.includes(optionId);

    // 🔁 Deselect / Disconnect if already selected
    if (isSelected) {
      this.resetSelection(option, optionId, tagsControl);
      return;
    }

    this.loadingCards.add(optionId);

    // 🧩 Handle workflow modal dependency
    if (this.handleWorkflowModal(option)) {
      this.loadingCards.delete(optionId);
      return;
    }

    // 🔐 Handle OAuth / Integration
    this.openIntegrationUrl(option);

    // 📡 Listen for SSE success
    this.listenForConnectionSuccess(option, tagsControl);
  }

  resetSelection(option: any, optionId: string, tagsControl: any): void {
    const modalCond = this.findModalCondition(option, 'disconnect');
    if (modalCond) {
      // Save modal context
      this.activeModalContext = {
        nodeId: modalCond.targetValue,
        selectedOption: option,
        selectedName: option.name,
        fieldName: this.fields.fieldName,
        fieldID: optionId,
        hasOpenedAuthUrl: false,
      };

      // Load disconnect form
      this.loadNode(modalCond.targetValue);

      // Show modal
      const modalId = `connection_modal_${this.fields.fieldName}`;
      const modal = document.getElementById(modalId);
      if (modal) modal.classList.add('show');

      this.loadingCards.delete(optionId);
      return;
    }

    // Fallback deselect
    let newValue: string[] = [];
    let newTags: string[] = [];

    if (this.fields?.fieldType === 'singleSelect') {
      newValue = [];
      newTags = [];
    } else {
      newValue = this.getSelectedIds().filter((id: string) => id !== optionId);
      const optionName = option.name;
      newTags = this.getSelectedTags(tagsControl).filter(
        (name: string) => name !== optionName,
      );
    }

    this.control?.setValue(newValue);
    tagsControl?.setValue(newTags);
    this.selectedOptions = [...newValue];
    this.loadingCards.delete(optionId);
    this.emitTaskMappingDependency(newTags);
  }

  handleWorkflowModal(option: any): boolean {
    const optionId = option?._id?.toString();
    const modalCond = this.findModalCondition(option, 'connect');
    if (!modalCond) return false;

    this.activeModalContext = {
      workflowId:
        modalCond.targetType === 'workflow' ? modalCond.targetValue : null,
      formId: modalCond.targetType === 'form' ? modalCond.targetValue : null,
      selectedOption: option,
      authUrl: option.integration?.authUrl,
      selectedName: option.name,
      fieldName: this.fields.fieldName,
      fieldID: optionId,
      hasOpenedAuthUrl: false,
    };

    if (modalCond.targetType === 'workflow') {
      this.loadWorkflow(modalCond.targetValue, 0);
    }

    if (modalCond.targetType === 'form') {
      this.loadNode(modalCond.targetValue);
    }

    const modalId = `connection_modal_${this.fields.fieldName}`;
    const modal = document.getElementById(modalId);
    if (modal) modal.classList.add('show');

    return true;
  }

  listenForConnectionSuccess(option: any, tagsControl: any): void {
    const optionId = option?._id?.toString();
    const optionName = option.name;

    const sub = this.SseService.getMessages().subscribe({
      next: (msg: any) => {
        try {
          const parsed = typeof msg === 'string' ? JSON.parse(msg) : msg;

          const isSuccess =
            parsed?.type === 'connectionSuccess' ||
            parsed?.type === 'connectSuccess' ||
            parsed?.payload?.status === 200;

          if (!isSuccess) return;

          this.applySelectedIntegration(optionId, optionName, tagsControl);

          this.loadingCards.delete(optionId);
          sub.unsubscribe();
        } catch (err) {
          console.error('Error parsing SSE message:', err);
        }
        this.cdr.detectChanges();
      },
      error: () => {
        sub.unsubscribe();
        this.cdr.detectChanges();
      },
    });
  }

  /** Loads the workflow and optionally a specific node */
  loadWorkflow(wId: string, nodeId?: any, nodeIndex?: any): void {
    this.workflowData = null;
    this.workflowService.loadWorkflow(wId).subscribe({
      next: ({ workflowData, recordId }) => {
        this.workflowData = workflowData;
        this.currentRecordId = recordId;
        this.workflowId = wId;
        this.cdr.markForCheck();
        // --- Handle second last node request ---
        if (nodeIndex === 'secondLastNode') {
          const nodes = workflowData?.nodes || [];

          if (nodes.length >= 2) {
            const secondLastNode = nodes[nodes.length - 2]; // ⭐ correct node
            this.currentNodeId = secondLastNode._id;
            this.loadNode(secondLastNode._id, recordId);
            return; // ⭐ STOP HERE, do NOT load startNodeId
          }
        }
        // --- Default start node logic ---
        const startNodeId = workflowData?.startNodeId;
        if (startNodeId) {
          this.currentNodeId = startNodeId;
          this.loadNode(startNodeId, recordId);
        } else {
          console.warn(`[Workflow] No startNodeId found for workflow: ${wId}`);
        }
        this.cdr.detectChanges();
      },
      error: (error: any) => {
        console.error(`[Workflow] Failed to load workflow (${wId}):`, error);
        this.cdr.detectChanges();
      },
    });
  }

  /** Loads a node and processes navigation-related metadata */
  loadNode(nodeId: string, recordId?: string): void {
    if (this.activeModalContext?.nodeId === nodeId) {
      this.currentNodeId = nodeId;
      this.currentNode = null;
      this.nextNodes = null;
      this.targetWorkflowId = null;
      this.cdr.detectChanges();
      return;
    }
    const node = this.workflowData?.nodes?.find((n: any) => n._id === nodeId);
    if (!node) {
      return;
    }

    this.currentNode = node;
    this.currentNodeId = node._id;
    const platformName =
      this.activeModalContext?.selectedOption?.platformName ||
      this.activeModalContext?.selectedName ||
      '';
    this.recordID =
      node.recordId && node.recordId.trim() !== ''
        ? node.recordId
        : recordId || platformName;
    this.loadPreviousNode();
    const nextNodeIndex = this.workflowData?.nodes?.findIndex(
      (n: any) => n._id === this.currentNode?._id,
    );

    const lastNodeIndex = this.workflowData?.nodes?.length - 1;
    const isLastNode = nextNodeIndex === lastNodeIndex;
    if (this.activeModalContext) {
      this.activeModalContext.lastNode = isLastNode;
    }
    this.cdr.detectChanges();
    const nextButtonObj =
      node.next?.find((n: any) =>
        ['next_button', 'submit_continue'].includes(n.buttonId),
      ) || node.next?.[0];

    if (!nextButtonObj) return;

    const condition = nextButtonObj.condition;
    if (Array.isArray(condition)) {
      for (const cond of condition) {
        if (cond?.targetType === 'node' && cond?.targetValue) {
          this.nextNodes = cond.targetValue;
          return;
        }
        if (cond?.targetNodeId) {
          this.nextNodes = cond.targetNodeId;
          return;
        }
        if (cond?.targetType === 'url' && cond?.targetValue) {
          this.targetValue = cond.targetValue;
          return;
        }
        if (cond?.targetType === 'workflow' && cond?.targetValue) {
          this.targetWorkflowId = cond.targetValue;
          return;
        }
      }
    } else if (typeof condition === 'object' && condition !== null) {
      if (nextButtonObj.targetType === 'node' && nextButtonObj.targetValue) {
        this.nextNodes = nextButtonObj.targetValue;
      } else if (nextButtonObj.targetNodeId) {
        this.nextNodes = nextButtonObj.targetNodeId;
      } else if (
        nextButtonObj.targetType === 'url' &&
        nextButtonObj.targetValue
      ) {
        this.targetValue = nextButtonObj.targetValue;
      } else if (
        nextButtonObj.targetType === 'workflow' &&
        nextButtonObj.targetValue
      ) {
        this.targetWorkflowId = nextButtonObj.targetValue;
      } else {
        console.warn(`[Workflow] No valid condition in nextButtonObj.`);
      }
    } else {
      console.warn(`[Workflow] Invalid or missing condition in node.`);
    }
  }

  /** Function to validate the card is selected or not then show error message */
  validateSelection(): boolean {
    const currentValue = (this.control?.value || []).map((v: any) =>
      v.toString(),
    );

    if (currentValue.length > 0) {
      this.showValidationError = false;
      return true;
    }

    if (this.fields.isRequired) {
      this.showValidationError = true;
      return false;
    }

    this.showValidationError = false;
    return true;
  }

  private findModalCondition(
    option: any,
    action: 'connect' | 'disconnect' = 'connect',
  ): any {
    const fieldDeps = option?.fieldDependencies || [];
    const onClickDep = Array.isArray(fieldDeps)
      ? fieldDeps.find((dep: any) => dep.trigger === 'onClick')
      : null;

    if (!onClickDep) return null;

    const isModalTarget = (c: any) =>
      c &&
      c.type === 'modal' &&
      ['workflow', 'form'].includes(c.targetType) &&
      c.targetValue;

    const matchesAction = (c: any, blockAction?: string) => {
      const act = c?.action || blockAction;
      if (action === 'disconnect') {
        return act === 'disconnect';
      }
      return !act || act === 'connect';
    };

    if (Array.isArray(onClickDep.conditions)) {
      for (const cond of onClickDep.conditions) {
        if (isModalTarget(cond) && matchesAction(cond)) {
          return cond;
        }
      }
    }

    const condition = onClickDep.condition;

    if (Array.isArray(condition)) {
      for (const condBlock of condition) {
        if (isModalTarget(condBlock) && matchesAction(condBlock)) {
          return condBlock;
        }
        if (Array.isArray(condBlock?.conditions)) {
          for (const cond of condBlock.conditions) {
            if (isModalTarget(cond) && matchesAction(cond, condBlock?.action)) {
              return cond;
            }
          }
        }
      }
    } else if (typeof condition === 'object' && condition !== null) {
      if (isModalTarget(condition) && matchesAction(condition)) {
        return condition;
      }
      if (Array.isArray(condition.conditions)) {
        for (const cond of condition.conditions) {
          if (isModalTarget(cond) && matchesAction(cond, condition.action)) {
            return cond;
          }
        }
      }
    }

    return null;
  }

  openConnect(option: any, id: string) {
    const modalCond = this.findModalCondition(option, 'connect');
    if (modalCond) {
      // ✅ Build modal context for app-modal-renderer
      this.activeModalContext = {
        workflowId: modalCond.targetValue,
        selectedOption: option,
        selectedName: option.name,
        recordID: this.recordID,
        workflowData: this.workflowData,
        authUrl: option.integration?.authUrl || null,
        hasOpenedAuthUrl: false,
      };

      // ✅ Load modal workflow
      this.loadWorkflow(
        this.activeModalContext.workflowId,
        0,
        'secondLastNode',
      );

      // ✅ Use dynamic modal ID
      const modalId = `connection_modal_${this.fields.fieldName}`;
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.add('show');
      }

      this.cdr.detectChanges();
      return;
    }
  }

  closeOnBackdropClick(event: MouseEvent, modalId: string) {
    const modal = document.getElementById(modalId);
    if (event.target === modal) {
      this.closeModal(modalId);
    }
  }

  closeModal(modalId: string) {
    const modal = document.getElementById(modalId);
    if (modal) modal.classList.remove('show');
    this.activeModalContext = null;
    this.activeComingSoonOption = null;
    this.stopPollingFromModalRenderer();
    this.currentNodeId = null;
    this.currentNode = null;
    this.workflowData = null;
    this.recordID = null;
    this.workflowId = null;
    this.currentRecordId = null;
    this.modalTitle = '';
    this.cdr.detectChanges();
  }

  stopPollingFromModalRenderer() {
    if (this.modalRendererRef) {
      this.modalRendererRef.stopChildPolling();
    }
  }

  onModalFormSaved(event: any): void {
    const optionId = this.activeModalContext?.selectedOption?._id;
    const tagsControl = this.formGroup.get(this.fields.fieldName + 'Tags');

    if (event?.success) {
      const savedRecordId = event.recordId || event._id || event?.data?._id;
      if (savedRecordId) {
        this.recordID = savedRecordId;
        if (this.activeModalContext) {
          this.activeModalContext.recordID = savedRecordId;
        }
        if (this.currentNode) {
          this.currentNode.recordId = savedRecordId;
        }
        const savedNode = this.workflowData?.nodes?.find(
          (n: any) => n._id === (event.formId || this.currentNodeId || this.currentNode?._id),
        );
        if (savedNode) {
          savedNode.recordId = savedRecordId;
        }
      }
      const option = this.activeModalContext?.selectedOption;
      if (option && option.name) {
        console.log(`✅ Connection completed for: ${option.name}`);
      }

      const { nextNodeId, targetValue, targetWorkflowId, isSseTrigger } =
        this.resolveNavigationTargets(this.currentNode);

      const currentIndex = this.workflowData?.nodes?.findIndex(
        (n: any) => n._id === this.currentNode?._id,
      );

      const nextNodeIndex = this.workflowData?.nodes?.findIndex(
        (n: any) => n._id == nextNodeId,
      );
      const lastNodeIndex = this.workflowData?.nodes?.length - 1;

      const isLastNode = currentIndex === lastNodeIndex;
      const isNextNodeTheLastNode = nextNodeIndex === lastNodeIndex;

      const firstNodeId = this.workflowData?.nodes?.[0]?._id;

      // 🌐 Handle OAuth for first node if needed (only once per modal context)
      if (
        this.currentNode?._id === firstNodeId &&
        option?.integration?.authUrl &&
        this.activeModalContext?.selectedName != 'Jira' &&
        !this.activeModalContext?.hasOpenedAuthUrl
      ) {
        this.activeModalContext.hasOpenedAuthUrl = true;
        let authUrlTemplate = option.integration.authUrl;
        const catCode = option.categoryCode ||
          option.integration?.categoryCode ||
          this.fields?.displayName ||
          '';
        const recordIdVal = String(this.recordID || this.activeModalContext?.recordID || this.currentRecordId || savedRecordId || event.recordId || '');
        let authUrl = authUrlTemplate
          .replace('{{base}}', this.endpoint)
          .replace(/\{\{categoryCode\}\}/g, catCode)
          .replace(/\{\{integrationProfileRecordID\}\}/g, recordIdVal);
        this.accessToken = localStorage.getItem('accessToken') || '';
        const separator = authUrl.includes('?') ? '&' : '?';
        authUrl += `${separator}at=${encodeURIComponent(this.accessToken)}`;
        window.open(authUrl, '_blank');
      }

      // 🔥 NEW: Mark selected when NEXT NODE is the LAST node
      if (isNextNodeTheLastNode && !isLastNode) {
        const newValue = this.applySelectedIntegration(
          this.activeModalContext?.selectedOption?._id?.toString(),
          this.activeModalContext?.selectedOption?.name,
          tagsControl,
        );

        this.currentNode.selectedOptions = newValue;
        this.workflowData.selectedOptions = newValue;

        this.loadingCards.delete(optionId);
        this.cdr.detectChanges();
      }

      // ✅ When reaching last node (normal behavior)
      if (isLastNode) {
        this.applySelectedIntegration(
          this.activeModalContext?.selectedOption?._id?.toString(),
          this.activeModalContext?.selectedOption?.name,
          tagsControl,
        );

        this.loadingCards.delete(optionId);
        this.currentNode.selectedOptions = this.selectedOptions;
        this.workflowData.selectedOptions = this.selectedOptions;
        this.cdr.detectChanges();
      }

      // ✅ Handle workflow transitions
      if (nextNodeId && !isSseTrigger) {
        this.loadNode(nextNodeId, savedRecordId || event?.recordId);
        this.cdr.detectChanges();
        return;
      }

      if (targetValue) {
        const token = localStorage.getItem('accessToken');
        if (token) {
          window.location.href = `${targetValue}/${token}`;
          return;
        }
      }

      if (targetWorkflowId) {
        this.loadWorkflow(targetWorkflowId);
        this.cdr.detectChanges();
        return;
      }

      // 🔁 SSE Trigger
      if (isSseTrigger) {
        const sseTrigger = this.currentNode?.triggers?.find(
          (trigger: any) => trigger.event === 'listenSSE',
        );
        if (sseTrigger?.config?.url && sseTrigger?.config?.nextNodeId) {
          const apiEndpoint = environment.api_endpoint;
          const authToken = localStorage.getItem('accessToken') || '';
          const resolvedUrl = sseTrigger.config.url
            .replace('{{api_endpoint}}', apiEndpoint)
            .replace('{{authToken}}', authToken);

          // this.SseService.initSSE(resolvedUrl);
          this.loadNode(sseTrigger.config.nextNodeId, savedRecordId || event?.recordId);
          this.cdr.detectChanges();
          return;
        }
      }

      // ✅ Close modal properly
      const modalId = `connection_modal_${this.fields.fieldName}`;
      this.closeModal(modalId);
      this.cdr.detectChanges();
    }
  }

  /** Resolves navigation targets from current node */
  resolveNavigationTargets(node: any): {
    nextNodeId: string | null;
    targetValue: string | null;
    targetWorkflowId: string | null;
    recordId: string | null;
    isSseTrigger?: boolean;
  } {
    const fallback = {
      nextNodeId: null,
      targetValue: null,
      targetWorkflowId: null,
      recordId: node?.recordId ?? null,
      isSseTrigger: false,
    };

    if (!node?.next || !Array.isArray(node.next)) return fallback;

    const nextButtonObj =
      node.next.find((n: any) =>
        ['next_button', 'submit_continue'].includes(n.buttonId),
      ) || node.next[0];

    if (!nextButtonObj) return fallback;

    const resolveSseTrigger = (): {
      nextNodeId: string | null;
      isSseTrigger: boolean;
    } => {
      const sseTrigger = node.triggers?.find(
        (trigger: any) => trigger.event === 'listenSSE',
      );
      if (sseTrigger?.config?.nextNodeId) {
        return { nextNodeId: sseTrigger.config.nextNodeId, isSseTrigger: true };
      }
      return { nextNodeId: null, isSseTrigger: false };
    };

    const condition = nextButtonObj.condition;

    if (Array.isArray(condition)) {
      for (const cond of condition) {
        if (cond?.targetType === 'node' && cond?.targetValue) {
          return { ...fallback, nextNodeId: cond.targetValue };
        }
        if (cond?.targetNodeId) {
          return { ...fallback, nextNodeId: cond.targetNodeId };
        }
        if (cond?.targetType === 'url' && cond?.targetValue) {
          return { ...fallback, targetValue: cond.targetValue };
        }
        if (cond?.targetType === 'workflow' && cond?.targetValue) {
          return { ...fallback, targetWorkflowId: cond.targetValue };
        }
        if (cond?.targetType === 'manual') {
          const { nextNodeId, isSseTrigger } = resolveSseTrigger();
          if (nextNodeId) return { ...fallback, nextNodeId, isSseTrigger };
        }
      }
    } else if (typeof condition === 'object' && condition !== null) {
      if (nextButtonObj.targetType === 'node' && nextButtonObj.targetValue) {
        return { ...fallback, nextNodeId: nextButtonObj.targetValue };
      }
      if (nextButtonObj.targetNodeId) {
        return { ...fallback, nextNodeId: nextButtonObj.targetNodeId };
      }
      if (nextButtonObj.targetType === 'url' && nextButtonObj.targetValue) {
        return { ...fallback, targetValue: nextButtonObj.targetValue };
      }
      if (nextButtonObj.targetType === 'manual') {
        const { nextNodeId, isSseTrigger } = resolveSseTrigger();
        if (nextNodeId) return { ...fallback, nextNodeId, isSseTrigger };
      }
    }
    return fallback;
  }

  /** Function to set the modal title */
  setModalTitle(title: string) {
    this.modalTitle = title;
  }

  /** Loads previous node info for back navigation */
  loadPreviousNode(): void {
    const prevBtn = this.currentNode?.previous?.find(
      (p: any) => p.buttonId === 'previous_button',
    );
    if (prevBtn?.targetNodeId) {
      this.previousNodeId = prevBtn.targetNodeId;
    } else {
      console.warn('[Workflow] Previous button or targetNodeId not found.');
    }
  }

  clickedOnPrevious() {
    const currentNode = this.workflowData.nodes.find(
      (n: any) => n._id === this.currentNodeId,
    );

    if (
      currentNode &&
      currentNode.previous &&
      currentNode.previous.length > 0
    ) {
      const { targetNodeId } = currentNode.previous[0];
      if (targetNodeId) {
        this.workflowData.currentNodeId = targetNodeId;
        this.loadNode(targetNodeId);
      }
    } else {
      console.warn(
        'No previous node found for:',
        this.workflowData.currentNodeId,
      );
    }
  }

  checkPollingServiceForError(value: any) {
    // 🔍 Find the "attempts" condition in the current node’s next array
    const attemptNode = this.currentNode?.next?.find((next: any) =>
      next.condition.some((condGroup: any) =>
        condGroup.conditions.some((cond: any) => cond.type === 'attempts'),
      ),
    );

    if (attemptNode) {
      const targetNodeId = attemptNode?.condition?.[0]?.targetValue;
      const targetType = attemptNode?.condition?.[0]?.targetType;
      if (targetType === 'node' && targetNodeId) {
        this.loadNode(targetNodeId);
      } else if (targetType === 'workflow' && targetNodeId) {
        this.loadWorkflow(targetNodeId);
      } else {
        console.warn('⚠️ No valid target found for attempts condition');
      }
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey() {
    if (this.fields?.fieldName) {
      this.closeModal('connection_modal_' + this.fields.fieldName);
      this.closeModal('coming_soon_modal_' + this.fields.fieldName);
    }
  }

  private emitTaskMappingDependency(tags: any[]) {
    const normalizedTags = Array.isArray(tags) ? tags : [];
    const signature = normalizedTags.join('|');

    if (signature === this.lastTaskMappingSignature) {
      return;
    }

    this.lastTaskMappingSignature = signature;
    this.handleTaskMappingDependency.emit({
      fieldName: this.fields?.fieldName,
      tags: normalizedTags,
      selectedQuestion: this.fields?.displayName || '',
    });
  }

  handleImageError(option: any, event: Event) {
    this.integrationIconService.handleImageError(option, event);
  }
}
